import API from './API';

const path = `contextos`;

const ContextService = {
    // FILTROS
    filters: async filters => await API.filters(path, filters),

    // LISTAR TODOS
    list: async () => await API.list(path),

    // LISTAR UM
    find: async id => await API.find(path, id),

    // EDITAR
    edit: async (id, context) => await API.edit(path, id, context),

    // VERIFICAR INTEGRACOES
    verificarIntegracoes: async () => await API.list(`${path}/verificar-integracoes`),

    // PERIODOS EM CONTEXTOS
    periodos: async () => await API.list(`${path}/periodos`),
}

export default ContextService;